/**
 * Registers a block variation.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-variations/
 */
import { registerBlockVariation } from '@wordpress/blocks';
import { __ } from '@wordpress/i18n';
import { SVG, Path, Polygon, Rect, G } from '@wordpress/primitives';

const archiveIcon = (
	<SVG viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
		<G transform="matrix(.049914 0 0 .049914 -6.948 -5.0655)">
			<Rect x="139.2" y="558.56" width="423.26" height="21.705" />
			<Rect x="155.9" y="516.82" width="390.7" height="30.055" />
			<Rect x="153.39" y="174.54" width="388.62" height="41.742" />
			<Polygon points="551.19 149.07 347.7 101.49 144.21 149.07 155.9 162.01 347.7 162.01 539.51 162.01" />

			<Path d="m209.45 348.42c-0.335-20.5-0.866-41.001-1.669-61.487-0.756-19.302-2-38.585-2.939-57.881-0.081-1.666-0.787-2.026-2.169-2.328-5.693-1.241-11.416-1.824-17.163-1.833-5.747 9e-3 -11.47 0.592-17.163 1.833-1.382 0.301-2.088 0.662-2.169 2.328-0.939 19.296-2.183 38.579-2.939 57.881-0.803 20.486-1.335 40.987-1.669 61.487-0.237 14.528-0.09 29.067 0.14 43.599 0.254 16.121 0.612 32.246 1.265 48.355 0.7 17.288 1.782 34.562 2.731 51.839 0.182 3.311 0.521 6.613 0.78 9.831 6.379 1.66 12.704 2.619 19.025 2.698 6.321-0.079 12.645-1.038 19.025-2.698 0.259-3.218 0.597-6.521 0.779-9.831 0.949-17.277 2.031-34.551 2.731-51.839 0.653-16.109 1.011-32.234 1.265-48.355 0.229-14.532 0.377-29.071 0.139-43.599z" />
			<Path d="m315.26 348.42c-0.335-20.5-0.867-41.001-1.67-61.487-0.757-19.302-2.001-38.585-2.939-57.881-0.081-1.666-0.786-2.026-2.169-2.328-5.692-1.241-11.416-1.824-17.162-1.833-5.747 9e-3 -11.47 0.592-17.163 1.833-1.382 0.301-2.088 0.662-2.169 2.328-0.938 19.296-2.183 38.579-2.939 57.881-0.803 20.486-1.335 40.987-1.669 61.487-0.237 14.528-0.09 29.067 0.139 43.599 0.255 16.121 0.612 32.246 1.265 48.355 0.701 17.288 1.782 34.562 2.731 51.839 0.182 3.311 0.521 6.613 0.779 9.831 6.38 1.66 12.705 2.619 19.025 2.698 6.321-0.079 12.645-1.038 19.025-2.698 0.258-3.218 0.597-6.521 0.779-9.831 0.948-17.277 2.03-34.551 2.73-51.839 0.653-16.109 1.011-32.234 1.266-48.355 0.231-14.532 0.378-29.071 0.141-43.599z" />
			<Path d="m437.97 348.42c-0.335-20.5-0.866-41.001-1.67-61.487-0.756-19.302-2-38.585-2.938-57.881-0.082-1.666-0.787-2.026-2.17-2.328-5.692-1.241-11.415-1.824-17.162-1.833-5.747 9e-3 -11.47 0.592-17.163 1.833-1.382 0.301-2.088 0.662-2.169 2.328-0.938 19.296-2.183 38.579-2.938 57.881-0.804 20.486-1.335 40.987-1.67 61.487-0.237 14.528-0.09 29.067 0.14 43.599 0.255 16.121 0.612 32.246 1.265 48.355 0.701 17.288 1.782 34.562 2.731 51.839 0.183 3.311 0.521 6.613 0.779 9.831 6.38 1.66 12.704 2.619 19.025 2.698 6.321-0.079 12.645-1.038 19.025-2.698 0.258-3.218 0.597-6.521 0.779-9.831 0.949-17.277 2.03-34.551 2.731-51.839 0.652-16.109 1.01-32.234 1.265-48.355 0.23-14.532 0.377-29.071 0.14-43.599z" />
			<Path d="m541.28 348.42c-0.335-20.5-0.866-41.001-1.669-61.487-0.757-19.302-2.001-38.585-2.939-57.881-0.082-1.666-0.787-2.026-2.17-2.328-5.691-1.241-11.415-1.824-17.162-1.833-5.746 9e-3 -11.47 0.592-17.162 1.833-1.383 0.301-2.088 0.662-2.169 2.328-0.939 19.296-2.184 38.579-2.939 57.881-0.803 20.486-1.335 40.987-1.67 61.487-0.237 14.528-0.09 29.067 0.14 43.599 0.255 16.121 0.612 32.246 1.266 48.355 0.7 17.288 1.782 34.562 2.73 51.839 0.183 3.311 0.521 6.613 0.779 9.831 6.381 1.66 12.705 2.619 19.025 2.698 6.321-0.079 12.646-1.038 19.025-2.698 0.259-3.218 0.597-6.521 0.779-9.831 0.949-17.277 2.031-34.551 2.731-51.839 0.653-16.109 1.01-32.234 1.265-48.355 0.23-14.532 0.378-29.071 0.14-43.599z" />
		</G>
	</SVG>
);

registerBlockVariation( 'core/embed', {
	name: 'mediaformat/embed-archive-org',
	title: __( 'Archive.org Embed', 'mediaformat-embed-archive-org' ),
	description: __(
		'Embed media from Archive.org',
		'mediaformat-embed-archive-org'
	),
	icon: {
		src: archiveIcon,
	},
	category: 'embed',
	keywords: [
		'archive',
		'internet archive',
		'digital library',
		'video',
		'audio',
		'podcast',
	],
	attributes: {
		providerNameSlug: 'archive-org',
	},
	patterns: [ /^https?:\/\/(www\.)?archive\.org\/.+/i ],
	isActive: [ 'providerNameSlug' ],
} );
